module.exports = __webpack_public_path__ + "static/media/r147.d0da0210.jpg";